import { FormActionsMui } from '@app/components/form/FormActionsMui';
import { zodResolver } from '@hookform/resolvers/zod';
import { socialExport } from '@mi-front/api-clients';
import { FormContainer } from 'react-hook-form-mui';
import { useIntl } from 'react-intl';
import { z } from 'zod';
import { BaseSettingsFormProps } from '../../hooks/useSocialExportFactory';
import { FormSection } from '../../screens/manage/platforms/FormSection';
import { TikTokSettingsFields } from './components/TiktokSettingsFields';

export const tiktokSettingsSchema = z.object({
  privacyLevel: z.enum([
    'PUBLIC_TO_EVERYONE',
    'MUTUAL_FOLLOW_FRIENDS',
    'FOLLOWER_OF_CREATOR',
    'SELF_ONLY',
  ]),
  allowComment: z.boolean(),
  allowDuet: z.boolean(),
  allowStitch: z.boolean(),
});

export type TikTokSettingsFormValues = z.infer<typeof tiktokSettingsSchema>;

const defaultFormValues: TikTokSettingsFormValues = {
  privacyLevel: 'PUBLIC_TO_EVERYONE',
  allowComment: false,
  allowDuet: false,
  allowStitch: false,
};

function toFormValues(dto: socialExport.TiktokSettingsDto | undefined): TikTokSettingsFormValues {
  if (!dto) return defaultFormValues;
  return {
    privacyLevel: (dto.privacyLevel ??
      'PUBLIC_TO_EVERYONE') as TikTokSettingsFormValues['privacyLevel'],
    allowComment: dto.allowComment ?? false,
    allowDuet: dto.allowDuet ?? false,
    allowStitch: dto.allowStitch ?? false,
  };
}

export function TikTokSettingsForm({
  onUpdate,
  defaultSettings,
}: BaseSettingsFormProps<socialExport.TiktokSettingsDto>) {
  const { $t } = useIntl();

  return (
    <FormContainer
      mode="onBlur"
      values={toFormValues(defaultSettings)}
      onSuccess={async (formData: TikTokSettingsFormValues) => {
        await onUpdate({
          privacyLevel: formData.privacyLevel as socialExport.TiktokSettingsDtoPrivacyLevelEnumKey,
          allowComment: formData.allowComment,
          allowDuet: formData.allowDuet,
          allowStitch: formData.allowStitch,
        });
      }}
      resolver={zodResolver(tiktokSettingsSchema)}
    >
      <FormSection
        title={$t({
          id: 'socialExport.tiktok.settings.sectionTitle',
          defaultMessage: 'Valores por defecto para uploads',
        })}
      >
        <TikTokSettingsFields />
      </FormSection>
      <FormActionsMui cancel />
    </FormContainer>
  );
}
